module.exports = __webpack_public_path__ + "img/PontoOrvalho.fcb24f85.svg";